module.exports = __webpack_public_path__ + "img/2566-09-04 09.55.58.38ca10dc.jpg";